import React from 'react'
import Banner from './components/Banner'
import TagVeloe from './components/TagVeloe'
import Planos from './components/Planos'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import Loading from 'src/components/Loading'
import { ApolloProvider } from '@apollo/client'
import { client } from 'src/services/apollo'
import RecargaAutomatica from './components/RecargaAutomatica'
import ComoFunciona from './components/ComoFunciona'
import Beneficios from './components/Beneficios'

function Parcerias() {
	const { data, isLoading } = useFetchContent()
	// const offer = useMiddlewareOffer()

	if (isLoading || !data) return <Loading />

	return (
		<ApolloProvider client={client}>
			<Banner />
			<Planos />
			<RecargaAutomatica />
			<Beneficios />
			<ComoFunciona />
			<TagVeloe />
		</ApolloProvider>
	)
}

export default Parcerias
